<template>
    <fragment>
        <slot :attributes="attributes"></slot>
    </fragment>
</template>

<script>
import onboardingService from '../../core/services/onboardingService';

export default {
    name: "vue-onboarding-step",

    props: {
        step: [String, Number],
        name: String,

        value: {
            type: [String, Object, Array, Number, Boolean],
            default: true,
        },

        validated: {
            type: Boolean,
            default: true,
        }
    },

    data() {
        return {            
            currentStep: 1,
        };
    },

    watch: {
        
        "$tours.onboarding.currentStep"() {
            const currentStep = this.$tours.onboarding.currentStep + 1;
            this.currentStep = currentStep;

            if(this.currentStep === this.step) {
                if(!this.value || !this.validated) {
                    onboardingService.setAllowNextStepAction(false);
                }
                else {
                    onboardingService.setAllowNextStepAction(true);
                }
                
                this.$emit("active");
            }
        },

        value() {
            if(this.currentStep === this.step) {
                if(this.value && this.validated) {
                    onboardingService.setAllowNextStepAction(true);
                }
                else {
                    onboardingService.setAllowNextStepAction(false);
                }
            }
        }
    },

    computed: {
        onboardingStepAttribute() {
            return `data-${this.name}-step`;
        },

        attributes() {
            return { [this.onboardingStepAttribute]: this.step };
        }
    }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/VueOnboarding/VueOnboardingStep.vue